import { Offer } from "@/js/resources";
import { Form } from "@enymo/react-form-component";
import React from "react";
import { useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import Button from "../form/Button";
import EMailInput from "../form/EmailInput";
import Input from "../form/Input";
import Link from "../Link";
import PlanFrame from "../PlanFrame";

export interface Submit {
    email: string,
    password: string
}

export default function SignUp({
    className,
    redirect,
    offers,
    onSignUp
}: {
    className?: string,
    redirect?: string,
    offers: Offer[],
    onSignUp: (data: Submit) => Promise<void>
}) {
    const {t, i18n: {language: lng}} = useTranslation();
    const form = useForm<Submit>();

    return (
        <PlanFrame title={t("signUp.title")}>
            <div className="mt-12 flex flex-col gap-6 max-w-120 w-full">
                <Form form={form} onSubmit={onSignUp} className="flex flex-col rounded-xl px-5 sm:px-10 py-8 bg-bg-300 shadow-offer">
                    <h3 className="heading-l text-center lg:text-left">{t("signUp.signUp")}</h3>
                    <div className="mt-6 lg:mt-9 mb-9 lg:mb-12 flex flex-col gap-6">
                        <EMailInput placeholder={t("input.email.placeholder")} options={{
                            required: t("input.email.required")
                        }} />
                        <Input type="password" name="password" label={t("signUp.password")} placeholder={t("input.password.placeholder")} options={{
                            required: t("input.password.required"),
                            minLength: {
                                value: 8,
                                message: t("input.password.minLength")
                            }
                        }} />
                    </div>
                    <Button variant="primary" submit>{t("signUp.submit")}</Button>
                    <p className="body-s text-center mt-6">
                        <Trans i18nKey="signUp.terms">
                            By clicking "Sign Up", you accept our <Link to={`/${lng}/tos`}>Terms of Service</Link> and
                            our <Link to={`/${lng}/privacy`}>Privacy policy</Link>
                        </Trans>
                    </p>
                </Form>
                <span className="body-l-md text-center">
                    <Trans i18nKey="signUp.toLogin">
                        Already a member? <Link to={redirect ? (() => {
                            const searchParams = new URLSearchParams;
                            searchParams.set("redirect", redirect);
                            return `/login?${searchParams.toString()}`;
                        })() : "/login"}>Login now</Link>
                    </Trans>
                </span>
            </div>
        </PlanFrame>
    )
}